module.exports = __webpack_public_path__ + "static/media/tuxedo-pooh.a4ea4e1d.png";